<template>
  <div class="common-page-main main-page">
    <div class="field-box scroll-cotar">
      <div class="page-top-bar cfa">
        <div class="headline lfp">
          <span>Video Management</span>
        </div>
        <div class="rfp">
          <el-button size="small" icon="plus" type="primary" @click="showAddPop()">add</el-button>
        </div>
      </div>
      <div class="table-wrap">
        <el-table :data="table.data" v-loading="table.isLoading" element-loading-text="LOADING" style="width: 100%">
          <el-table-column label="Cover">
            <template scope="scope">
              <div class="common-table-row-img">
                <img :src="scope.row.VdCover" />
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="VdName" label="Name"></el-table-column>
          <el-table-column prop="VdUrl" label="Skip Url"></el-table-column>
          <el-table-column prop="VdSort" label="Sort"></el-table-column>
          <el-table-column label="Operate">
            <template scope="scope">
              <el-button size="small" v-on:click="showUpdatePop(scope.$index, scope.row)">edit</el-button>
              <el-button size="small" v-on:click="handleDel(scope.$index, scope.row)">delete</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="page-wrap">
        <el-pagination v-on:current-change="handleTableCurrentChange" :current-page="table.currentPage" :page-size="table.pageSize" layout="total, prev, pager, next" :total="table.pageTotal">
        </el-pagination>
      </div>
    </div>
    <!-- 详情弹出层 -->
    <el-dialog title="Video Detail" :visible.sync="page.popShow" size="tine">
      <VideoForm @addSuccess="handleAdd" @updateSuccess="handleUpdate" ref="popForm"></VideoForm>
    </el-dialog>
  </div>
</template>

<script>
// import $ from 'jquery'
// import mixin from '@/components/common/mixin'
import tools from '@/components/common/tools'
import VideoForm from '@/components/cms/VideoForm'

// 表格相关操作
let table = {
  methods: {
    getTableData: tools.commonTableDateFetch({
      url: '/Ajax/GetVideoListInAdmin',
      success(response) {
        let result = response.data
        this.table.data = result
      }
    }),
    refreshTableData() {
      this.getTableData(this.table.currentPage)
    }
  }
}

// 请求相关操作
let page = {
  methods: {
    // 删除操作
    delDataAjax(id) {
      tools.commonAjax.call(this, true, '/Ajax/DeleteVideoInAdmin', {
        Id: id
      }).then(() => {
        this.$message.success('delete success!')
        // 重新获取列表数据
        this.refreshTableData()
      })
    }
  }
}

export default {
  name: 'VideoManagement',
  mixins: [table, page],
  components: {
    VideoForm
  },
  created() {
    this.getTableData()
  },
  data() {
    return {
      table: {
        isLoading: false, // 是否正在加载
        ajaxData: {}, // 额外请求参数
        data: [], // 表格当前数据
        currentPage: 1, // 当前页码
        pageSize: 15, // 每页条数
        pageTotal: 0 // 总页数
      },
      page: {
        popShow: false
      }
    }
  },
  computed: {
  },
  methods: {
    // 页码点击事件
    handleTableCurrentChange(val) {
      this.getTableData(val)
    },
    // 显示add弹出层
    showAddPop() {
      this.page.popShow = true
      this.$nextTick(function() {
        this.$refs.popForm.resetValue()
      })
    },
    // 显示修改弹出层
    showUpdatePop(idx, item) {
      this.page.popShow = true
      this.$nextTick(function() {
        this.$refs.popForm.setValue(item)
      })
    },
    // add操作
    handleAdd() {
      // 刷新表格数据
      this.refreshTableData()
      this.page.popShow = false
    },
    // 修改操作
    handleUpdate() {
      // 刷新表格数据
      this.refreshTableData()
      this.page.popShow = false
    },
    // 删除操作
    handleDel(idx, item) {
      this.$confirm('This will permanently delete the record', 'prompt', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Canel',
        type: 'warning'
      }).then(() => {
        this.delDataAjax(item.Id)
      })
    }
  }
}
</script>

<style lang="scss">
@import "~@/style/lib-config";
</style>



// WEBPACK FOOTER //
// VideoManage.vue?243ed437